import fetchServices from "./FetchServices";
import ApiConstants from "../Utils/ApiConstant";
import { setUserById, setUsersData } from "../Store/Readux/Reducer/UsersSlice";
import { hideLoader, showLoader } from "../Store/Readux/Reducer/LoaderSlice";

export const getUsersList = () => async (dispatch, getState) => {
  dispatch(showLoader());

  try {
    let URL = ApiConstants.userURL;
    const method = "GET";
    const response = await fetchServices(URL, method, {});
    if (response.status_code === 200) {
      dispatch(setUsersData(response.data));
    }
    return response;
  } catch (error) {
    console.log(error.message);
  } finally {
    dispatch(hideLoader());
  }
};
export const addUser = (requestBody) => async (dispatch, getState) => {
  dispatch(showLoader());


  try {
    let URL = ApiConstants.userURL;
    const method = "POST";
    const response = await fetchServices(URL, method, requestBody);

    return response;
  } catch (error) {
    console.log(error.message);
  } finally {
    dispatch(hideLoader());
  }
};
export const updateUser = (requestBody, id) => async (dispatch, getState) => {
  dispatch(showLoader());


  try {
    let URL = ApiConstants.userURL + "/" + id;
    const method = "POST";
    const response = await fetchServices(URL, method, requestBody);

    return response;
  } catch (error) {
    console.log(error.message);
  } finally {
    dispatch(hideLoader());
  }
};
export const getUserById = (id) => async (dispatch, getState) => {
  dispatch(showLoader());

  try {
    let URL = ApiConstants.userURL + "/" + id;
    const method = "GET";
    const response = await fetchServices(URL, method, {});

    return response;
  } catch (error) {
    console.log(error.message);
  } finally {
    dispatch(hideLoader());
  }
};
export const getUserProfile = () => async (dispatch, getState) => {
  dispatch(showLoader());

  try {
    let URL = ApiConstants.userProfileURL;
    const method = "GET";
    const response = await fetchServices(URL, method, {});
    if (response.status_code === 200) {
      dispatch(setUserById(response.data));
    }
    return response;
  } catch (error) {
    console.log(error.message);
  } finally {
    dispatch(hideLoader());
  }
};